<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link
        class="flex text-indigo-400 group-hover:text-indigo-600"
        :href="route('social.register')"
      >
        <icon name="filter" class="w-6 h-9 mr-3 fill-indigo-400 group-hover:fill-indigo-600" />
        Filtros /
      </inertia-link>
      <span class="ml-1 font-medium"> Editar </span>
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.label"
            :error="form.errors.label"
            class="pr-6 pb-8 w-full lg:w-2/5"
            label="Título"
          />

          <select-input
            v-model="form.role_id"
            :error="form.errors.role_id"
            class="pr-6 pb-8 w-full lg:w-2/5"
            :class="{ hidden: false }"
            label="Papel"
          >
            <option :value="null">...</option>
            <option v-for="role in roles" :key="role.value" :value="role.value">
              {{ role.label }}
            </option>
          </select-input>

          <select-input
            v-model="form.current"
            :error="form.errors.current"
            class="pr-6 pb-8 w-full lg:w-1/5"
            label="Vigente"
          >
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Estados</label>
            <select
              v-model="form.state_id"
              class="form-select"
              label="Estados"
              @change="getCities()"
            >
              <option :value="null" />
              <option v-for="state in states" :key="state.value" :value="state.value">
                {{ state.label }}
              </option>
            </select>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Cidades:</label>
            <select v-model="form.city_id" class="form-select">
              <option :value="null" />
              <option
                v-for="city in userCities"
                :key="city.id"
                :value="city.id"
                :selected="form.city_id == city.id"
              >
                {{ city.name }}
              </option>
            </select>
          </div>

          <div
            class="w-full pr-6 pb-8"
            style="display: flex; flex-direction: row; align-items: center"
          >
            <label class="form-label" style="display: flex; align-items: center; margin-right: 5px">
              Redes Sociais:
            </label>

            <div
              style="display: flex; align-items: center; margin-right: 15px; margin-bottom: 0.5rem"
            >
              <input
                type="checkbox"
                style="margin-right: 5px; margin-top: 0; margin-bottom: 0"
                v-model="form.instagram"
                id="instagram-checkbox"
              />
              <label for="instagram-checkbox" style="display: flex; align-items: center">
                Instagram
              </label>
            </div>

            <div style="display: flex; align-items: center; margin-bottom: 0.5rem">
              <input
                type="checkbox"
                style="margin-right: 5px; margin-top: 0; margin-bottom: 0"
                v-model="form.tiktok"
                id="tiktok-checkbox"
                @change="toggleTiktokInputs"
              />
              <label for="tiktok-checkbox" style="display: flex; align-items: center">
                TikTok
              </label>
            </div>
          </div>

          <!-- Seção do Instagram -->
          <div v-if="form.instagram" class="w-full mb-8">
            <div class="section-header mb-4">
              <h2 class="text-xl font-semibold flex items-center">
                <i class="pi pi-instagram" style="font-size: 1.5rem; margin-right: 15px"></i>
                Instagram
              </h2>
              <div class="h-1 w-32 bg-gradient-to-r from-black to-pink-500 rounded"></div>
            </div>

            <div style="display: flex; flex-direction: row; gap: 15px; margin-bottom: 20px;">
                <input
                  type="radio"
                  style="margin-right: 5px; margin-top: 0; margin-bottom: 0"
                  v-model="form.apiInstagram"
                  id="instagram-radio-apify"
                  value="apify"
                />
                <label for="instagram-radio-apify" style="display: flex; align-items: center">
                  Apify
                </label>
              </div>
            <div
              v-for="(item, index) in form.values"
              :key="index"
              class="social-media-filter-form-container"
            >
              <text-input
                v-model="item.value"
                :type="item.type"
                class="pr-6 pb-8 w-full lg:w-2/5"
                label="Termo de Pesquisa"
              />
              <div class="social-media-filter-form-wrapper-icon">
                <div
                  v-if="form.values.length > 1"
                  class="social-media-filter-form-container-icon trash"
                  @click="delValue(index)"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 4H3.33333H14"
                      stroke="#F25362"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.33317 3.99992V2.66659C5.33317 2.31296 5.47365 1.97383 5.72369 1.72378C5.97374 1.47373 6.31288 1.33325 6.6665 1.33325H9.33317C9.68679 1.33325 10.0259 1.47373 10.276 1.72378C10.526 1.97383 10.6665 2.31296 10.6665 2.66659V3.99992M12.6665 3.99992V13.3333C12.6665 13.6869 12.526 14.026 12.276 14.2761C12.0259 14.5261 11.6868 14.6666 11.3332 14.6666H4.6665C4.31288 14.6666 3.97374 14.5261 3.72369 14.2761C3.47365 14.026 3.33317 13.6869 3.33317 13.3333V3.99992H12.6665Z"
                      stroke="#F25362"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.6665 7.33325V11.3333"
                      stroke="#F25362"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.3335 7.33325V11.3333"
                      stroke="#F25362"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção do TikTok -->
          <div v-if="form.tiktok" class="w-full mb-8">
            <div class="section-header mb-4">
              <h2 class="text-xl font-semibold flex items-center">
                <i class="fa-brands fa-tiktok" style="font-size: 1.5rem; margin-right: 15px"></i>
                TikTok
              </h2>
              <div class="h-1 w-32 bg-gradient-to-r from-black to-pink-500 rounded"></div>
            </div>

            <div style="display: flex; flex-direction: row; gap: 15px; margin-bottom: 20px;">
              <input
                type="radio"
                style="margin-right: 5px; margin-top: 0; margin-bottom: 0"
                v-model="form.apiTiktok"
                id="tiktok-radio-brightdata"
                value="brightdata"
              />
              <label for="tiktok-radio-brightdata" style="display: flex; align-items: center">
                Brightdata
              </label>
              <input
                type="radio"
                style="margin-right: 5px; margin-top: 0; margin-bottom: 0"
                v-model="form.apiTiktok"
                id="tiktok-radio-apify"
                value="apify"
              />
              <label for="tiktok-radio-apify" style="display: flex; align-items: center">
                Apify
              </label>
            </div>

            <!-- Seção de inputs do TikTok -->
            <div class="mb-4">
              <div
                v-for="(hashtagItem, index) in tiktokHashtags"
                :key="'tiktok-hashtag-' + index"
                class="social-media-filter-form-container"
              >
                <text-input
                  v-model="hashtagItem.search_keyword"
                  :type="'text'"
                  class="pr-6 pb-8 w-full lg:w-2/5"
                  label="Termo de Pesquisa"
                />
                <div class="social-media-filter-form-wrapper-icon">
                  <div
                    v-if="tiktokHashtags.length > 1"
                    class="social-media-filter-form-container-icon trash"
                    @click="removeHashtagItem(index)"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 4H3.33333H14"
                        stroke="#F25362"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.33317 3.99992V2.66659C5.33317 2.31296 5.47365 1.97383 5.72369 1.72378C5.97374 1.47373 6.31288 1.33325 6.6665 1.33325H9.33317C9.68679 1.33325 10.0259 1.47373 10.276 1.72378C10.526 1.97383 10.6665 2.31296 10.6665 2.66659V3.99992M12.6665 3.99992V13.3333C12.6665 13.6869 12.526 14.026 12.276 14.2761C12.0259 14.5261 11.6868 14.6666 11.3332 14.6666H4.6665C4.31288 14.6666 3.97374 14.5261 3.72369 14.2761C3.47365 14.026 3.33317 13.6869 3.33317 13.3333V3.99992H12.6665Z"
                        stroke="#F25362"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.6665 7.33325V11.3333"
                        stroke="#F25362"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.3335 7.33325V11.3333"
                        stroke="#F25362"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Botão Validar dados -->
          <div v-if="form.instagram || form.tiktok" class="w-full flex justify-end mt-4 mb-4">
            <loading-button
              @click="validateTerms"
              :loading="form.processing || isLoadingSocialMediaData"
              type="button"
              class="btn-indigo"
            >
              Validar dados
            </loading-button>
          </div>
        </div>
      </div>
    </div>
    <ModalSocialMediaData
      v-if="showModalSocialMediaData"
      :showModalSocialMediaData.sync="showModalSocialMediaData"
      :dataInstagram="modalSocialMediaData"
      :touristAttractionData="touristAttractionData"
      :influencers="influencersData"
      :upsertFilter="update"
      :term="this.form.instagram ? this.form.values[0].value : this.tiktokKeywords[0]"
      :tiktokKeywords="Array.isArray(this.tiktokKeywords) ? this.tiktokKeywords.join(', ') : this.tiktokKeywords"
      :isUpdate="true"
      :mediaPagination="mediaPagination"
      :cityId="this.form.city_id"
      :stateId="this.form.state_id"
      :snapshotId="this.snapshotId"
      :instagramSelected="!!this.form.instagram"
      :tiktokSelected="!!this.form.tiktok"
      :apiTiktok="this.form.apiTiktok"
      :tiktokData="this.originalTiktokData"
      @update:modalSocialMediaData="(updatedMedias) => (modalSocialMediaData = updatedMedias)"
      :isLoadingTiktokData="isLoadingTiktokData"
    />
    <Toast position="top-center" />
  </div>
</template>

<script>
import Layout from '../Components/Layout/Layout.vue'
import Icon from '@/Shared/Icon'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import axios from 'axios'
import LoadingButton from '@/Shared/LoadingButton'
import Toast from 'primevue/toast'
import ModalSocialMediaData from './ModalSocialMediaData'
import { mapState } from 'pinia'
import { useSocialMedia } from '@/stores/socialMedia'

export default {
  components: {
    Icon,
    SelectInput,
    TextInput,
    LoadingButton,
    Toast,
    ModalSocialMediaData,
  },
  layout: Layout,
  remember: 'form',
  props: {
    states: Array,
    roles: Array,
    researchs: Object,
    values: Array,
    cities: Array,
    tiktokData: Array,
  },
  data() {
    return {
      showFilterValues: false,
      isLoadingSocialMediaData: false,
      isLoadingTiktokData: false,
      showModalSocialMediaData: false,
      modalSocialMediaData: [],
      touristAttractionData: [],
      mediaPagination: null,
      influencersData: [],
      searchCities: null,
      routeId: null,
      snapshotId: '',
      tiktokHashtags: [],
      tiktokKeywords: [],
      form: this.$inertia.form({
        label: this.researchs.label,
        role_id: this.researchs.role_id,
        state_id: this.researchs.state_id,
        city_id: this.researchs.city_id,
        current: this.researchs.current,
        tiktok: this.researchs.tiktok,
        instagram: this.researchs.instagram,
        values: this.values,
        limit_per_input: 100,
        excludedPosts: [''],
        apiInstagram: 'apify',
        apiTiktok: 'brightdata',
      }),
      userCities: this.cities,
      originalTiktokData: [],
    }
  },
  mounted() {
    this.routeId = window.location.pathname.replace(/\D/g, '')

    // Se o TikTok estiver selecionado e existirem dados, inicializa os inputs com os dados existentes
    if (this.form.tiktok && this.tiktokData && this.tiktokData.length > 0) {
      this.initializeTiktokInputs()
    } else if (this.form.tiktok) {
      // Caso esteja selecionado mas não tenha dados, cria um input vazio
      this.addHashtagItem()
    }
  },
  computed: {
    ...mapState(useSocialMedia, ['selectedTopInfluencers']),
    ...mapState(useSocialMedia, ['selectedHashtags']),
    ...mapState(useSocialMedia, ['selectedTouristAttractions']),
  },
  methods: {
    initializeTiktokInputs() {
      this.tiktokHashtags = []
      // Se não foram adicionados itens, adicione um vazio
      if (this.tiktokHashtags.length === 0) {
        this.addHashtagItem()
      }

      // Define o snapshotId se estiver disponível no primeiro item
      if (this.tiktokData.length > 0 && this.tiktokData[0].snapshot_id) {
        this.snapshotId = this.tiktokData[0].snapshot_id
      }
      this.originalTiktokData = JSON.parse(JSON.stringify(this.tiktokData))
    },
    toggleTiktokInputs() {
      if (this.form.tiktok && this.tiktokHashtags.length === 0) {
        this.addHashtagItem()
      }
    },

    distributePostsAmongHashtags() {
      const totalPosts = parseInt(this.form.limit_per_input)
      const hashtagCount = this.tiktokHashtags.length

      if (hashtagCount === 0) return

      // Calcula a quantidade de posts por hashtag (arredondando para baixo para evitar números quebrados)
      const postsPerHashtag = Math.floor(totalPosts / hashtagCount)

      // Atribui a quantidade calculada para cada hashtag
      this.tiktokHashtags.forEach((hashtag) => {
        hashtag.num_of_posts = postsPerHashtag
      })
    },

    // Adicionar uma nova função para validar os posts
    validateTiktokPosts() {
      if (!this.form.tiktok) return true

      const totalPosts = parseInt(this.form.limit_per_input)
      const totalPostsSum = this.tiktokHashtags.reduce(
        (sum, hashtag) => sum + parseInt(hashtag.num_of_posts || 0),
        0,
      )

      if (totalPostsSum > totalPosts) {
        this.$toast.add({
          severity: 'error',
          summary: 'Limite excedido',
          detail: `A soma dos posts de cada hashtag (${totalPostsSum}) não pode ultrapassar o limite total de posts (${totalPosts}).`,
          life: 5000,
        })
        return false
      }

      return true
    },

    // Adicionar um novo item de hashtag
    addHashtagItem() {
      this.tiktokHashtags.push({
        search_keyword: '',
        num_of_posts: 100,
        posts_to_exclude_array: [''],
      })
    },

    // Remover um item de hashtag
    removeHashtagItem(index) {
      if (this.tiktokHashtags.length > 1) {
        this.tiktokHashtags.splice(index, 1)
      }
    },

    // Adicionar um novo post para excluir em um item de hashtag específico
    addExcludedPost(hashtagIndex) {
      this.tiktokHashtags[hashtagIndex].posts_to_exclude_array.push('')
    },

    // Remover um post para excluir de um item de hashtag específico
    removeExcludedPost(hashtagIndex, postIndex) {
      if (this.tiktokHashtags[hashtagIndex].posts_to_exclude_array.length > 1) {
        this.tiktokHashtags[hashtagIndex].posts_to_exclude_array.splice(postIndex, 1)
      }
    },

    // Preparar dados do TikTok para envio
    prepareTiktokData() {
      const formattedData = this.tiktokHashtags.map((item) => {
        // Converte o array de posts_to_exclude_array para a string posts_to_not_include
        return {
          search_keyword: item.search_keyword.replace(/\s/g, ''),
          num_of_posts: item.num_of_posts,
          posts_to_not_include: item.posts_to_exclude_array.filter((post) => post.trim() !== ''),
        }
      })

      return formattedData
    },

    async collectTiktokData() {
      try {
        this.isLoadingTiktokData = true
        const tiktokData = this.prepareTiktokData()
        let body;
        if(this.form.apiTiktok === 'brightdata'){
          body = {
            data: [{"search_keyword": tiktokData[0].search_keyword, "num_of_posts":1000, "posts_to_not_include":[]}],
            limit_per_input: 1000,
            api: this.form.apiTiktok,
          }
        }else{
          body = {
            search: tiktokData[0].search_keyword,
            api: this.form.apiTiktok,
          }
        }
        const response = await axios.post(`/api/social-media/tiktok`, body)
        if(this.form.apiTiktok === 'brightdata'){
          this.snapshotId = response.data.snapshot_id || null
          this.tiktokData.status = 'running'
        } else {
          this.originalTiktokData = response.data

        }
        setTimeout(() => {
          this.tiktokKeywords = tiktokData[0].search_keyword
        }, 2000)
      } catch (error) {
        this.isLoadingTiktokData = false
        console.error('Erro ao coletar dados do TikTok:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Erro ao coletar dados do TikTok',
          life: 3000,
        })
      } finally {
        this.isLoadingTiktokData = false
      }
    },

    async getInstagramData() {
      this.isLoadingSocialMediaData = true
      try {
        const response = await axios.post(`/api/social-media/instagram`, {
          search: this.form.values[0].value,
          cityId: this.form.city_id,
          api: this.form.apiInstagram,
        })
        if (response) {
          this.modalSocialMediaData = response.data.medias
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Não existe hashtag com esse termo',
          life: 3000,
        })
      } finally {
        if (!this.form.tiktok) {
          this.showModalSocialMediaData = true
        }
      }
    },

    async getTouristAttractions() {
      try {
        const response = await axios.post(`/api/social-media/tourist-attraction`, {
          term: this.form.instagram ? this.form.values[0].value : this.tiktokKeywords[0],
          cityId: this.form.city_id,
          stateId: this.form.state_id,
          roleId: this.form.role_id,
          isEdit: true,
        })
        this.touristAttractionData = response.data
      } catch (error) {
        console.error('Erro ao obter atrações turísticas:', error)
      }
    },

    async getTopInfluencers() {
      try {
        const response = await axios.get(`/api/social-media/influencers/${this.routeId}`)
        this.influencersData = response.data
      } catch (error) {
        console.error('Erro ao obter influenciadores:', error)
      }
    },

    async validateTerms() {
      if (!this.form.tiktok && !this.form.instagram) {
        this.$toast.add({
          severity: 'error',
          summary: 'Selecione uma das redes sociais para buscar os dados',
          life: 3000,
        })
        return false
      }
      try {
        this.isLoadingSocialMediaData = true
        const promises = []
        if (this.form.instagram) {
          promises.push(this.getInstagramData())
        }
        if (this.form.tiktok) {
          promises.push(this.collectTiktokData())
        }
        await Promise.all(promises)
        setTimeout(async () => {
          await this.getTouristAttractions()
          await this.getTopInfluencers()
        }, 2000)
      } catch (error) {
        console.error('Erro ao validar termos:', error)
        this.isLoadingSocialMediaData = false
        this.$toast.add({
          severity: 'error',
          summary: 'Erro ao validar os termos',
          life: 3000,
        })
      } finally {
        this.isLoadingSocialMediaData = false
        this.showModalSocialMediaData = true
      }
    },

    closeDialog() {
      this.showModalSocialMediaData = false
    },

    async update() {
      try {
        const tiktokData = this.prepareTiktokData()

        const values = this.form.instagram
          ? this.form.values
          : tiktokData.map((item) => ({
              type: '',
              value: item.search_keyword,
            }))

        const body = {
          label: this.form.label,
          role_id: this.form.role_id,
          current: this.form.current,
          state_id: this.form.state_id,
          city_id: this.form.city_id,
          values: values,
          topInfluencers: this.selectedTopInfluencers,
          hashtags: this.selectedHashtags,
          touristAttractios: this.selectedTouristAttractions,
          tiktok: this.form.tiktok,
          instagram: this.form.instagram,
          limit_per_input: this.form.limit_per_input,
          tiktokData,
          apiInstagram: this.form.apiInstagram,
          apiTiktok: this.form.apiTiktok,
        }

        const response = await axios.put(`/api/social-media/update-filter/${this.routeId}`, body)
        if (response.data) {
          this.showModalSocialMediaData = false
          this.isLoadingSocialMediaData = false
          this.modalSocialMediaData = []
          this.$toast.add({
            severity: 'success',
            summary: 'Termos atualizado com sucesso',
            life: 3000,
          })
        }
      } catch (error) {
        console.error('Erro ao atualizar filtro:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Erro ao atualizar filtro',
          life: 3000,
        })
        this.isLoadingSocialMediaData = false
      }
    },
    getCities() {
      axios
        .get(this.route('cities'), {
          params: {
            stateId: this.form.state_id,
          },
        })
        .then((response) => {
          this.form.city_id = null
          this.userCities = response.data
        })
    },

    addValues() {
      this.form.values.push({
        type: 'text',
        value: null,
        start_date: null,
        end_date: null,
      })
      this.showFilterValues = true
    },

    delValue(index) {
      this.form.values.splice(index, 1)
    },
  },
}
</script>

<style>
.btn {
  border-radius: 8px;
  padding: 12px 20px;
  background-color: #001a28;
  color: #f2f4f5;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
}

.btn:hover {
  transform: scale(1.1);
}

.social-media-filter-container-new-button {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.social-media-filter-container-new-button-title {
  display: inline-block;
  font-size: 1.375rem;
  font-weight: 600;
  color: #202a2f;
  margin-bottom: 10px;
}
.social-media-filter-form-container {
  display: flex;
  width: 92.5vw;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;
  border: 1px solid #cad2d6;
  border-radius: 16px;
  margin-bottom: 30px;
}
.social-media-filter-form-container:not(:last-child) {
  margin-bottom: 10px;
}
.social-media-filter-form-wrapper-icon {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
}
.social-media-filter-form-container-icon {
  display: flex;
  justify-content: center;
  padding: 13px;
  gap: 10px;
  background: #f2f4f5;
  border-radius: 8px;
  cursor: pointer;
}
.social-media-filter-form-container-icon:hover {
  filter: brightness(1.5);
}
.duplicate {
  border: 1px solid #64b4c8;
}
.trash {
  border: 1px solid #f25362;
}

.social-media-filter-container-new-button {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.social-media-filter-container-new-button-title {
  display: inline-block;
  font-size: 1.375rem;
  font-weight: 600;
  color: #202a2f;
  margin-bottom: 10px;
}

.social-media-filter-form-container {
  display: flex;
  width: 92.5vw;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 16px;
  border: 1px solid #cad2d6;
  border-radius: 16px;
  margin-bottom: 30px;
}
.social-media-filter-form-container:not(:last-child) {
  margin-bottom: 10px;
}
.social-media-filter-form-wrapper-icon {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
}
.social-media-filter-form-container-icon {
  display: flex;
  justify-content: center;
  padding: 13px;
  gap: 10px;
  background: #f2f4f5;
  border-radius: 8px;
  cursor: pointer;
}
.social-media-filter-form-container-icon:hover {
  filter: brightness(1.5);
}
.duplicate {
  border: 1px solid #64b4c8;
}
.trash {
  border: 1px solid #f25362;
}
.check {
  border: 1px solid #3cb043;
}

.delete-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  transition: all 0.2s ease;
  margin-top: 5px;
}

.delete-btn:hover {
  transform: scale(1.2);
}

.dialog-social-media-card {
  position: relative;
  padding-bottom: 35px;
}

.dialog-social-media-card .delete-btn {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>
